import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {GuestService} from "../_services/guest.service";

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(private guestService: GuestService,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = this.guestService.getToken();

    // daca nu avem setat guestJWT, atunci se va afisa pagina guest login
    if (!token) {
      this.router.navigate(["/authentication/signinguest"]);
    }

    return true;
  }
}
